import React, { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import LoadingSpinner from '../common/LoadingSpinner';
import { getErrorMessages } from '../../utils';


type TFreelancerDetailsAgentNotesProps = {
    agentNotes: string;
    onSave: (fields: any) => Promise<AxiosResponse>;
    isTable?: boolean;
}

export default function FreelancerDetailsAgentNotes({
    agentNotes,
    onSave,
    isTable = false,
}: TFreelancerDetailsAgentNotesProps) {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState(null);
    const [fields, setFields] = useState({
        agent_notes: agentNotes,
    });

    const handleOnAgentNotesChange = (value: string) => {
        setFields(prevFields => ({ ...prevFields, agent_notes: value }));
    };

    useEffect(() => {
        handleOnAgentNotesChange(agentNotes);
    }, [agentNotes]);

    const handleOnAgentNotesBlur = () => {
        setIsLoading(true);
        setErrorMessages(null);

        onSave(fields)
            .then(() => {
                setIsLoading(false);
            })
            .catch(err => {
                setErrorMessages(getErrorMessages(err));
                setIsLoading(false);
            });
    };

    return (
        <div className="freelancer-details-header__agent-notes">
            {errorMessages && (
                <div className="agent-notes-errors">
                    <p>Could not update the notes: {errorMessages}</p>
                </div>
            )}
            {isLoading ? (
                <LoadingSpinner
                    className="agent-notes agent-notes-spinner"
                />
            ) : (
                <textarea
                    className={`agent-notes agent-notes-input__${isTable ? 'table' : 'details'}`}
                    value={fields.agent_notes || ''}
                    onChange={event => handleOnAgentNotesChange(event.target.value)}
                    onBlur={handleOnAgentNotesBlur}
                    placeholder="No notes yet..."
                />
            )}
        </div>
    );
}
